//
export default [
    'sl_customer',
    'sl_customer_branch_offices',
    'pos_sale',
    'pos_sale.g_seller_user',
    'pos_sale.g_seller_user.hr_employee',
    'pos_sale.payment_types',
    'g_state',
    'wh_detail_dispatch_requests',
    'wh_detail_dispatch_requests.wh_product',
    'wh_detail_dispatch_requests.wh_warehouse',
]
